import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http:HttpClient) { }

  checkCredential(body){
    return this.http.post('login',body);
  }
 checkUser(email){
    return this.http.post(`checkForRegisteredEmailId`,email);
  }
  verifyOtp(data){
    return this.http.post(`verifyOtp`,data);
  }
  resetPassword(data){
    return this.http.post(`resetPassword`,data);
  }
}
